var _defs, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelayedIncome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M33.15 26.392a13.401 13.401 0 01-5.088 6.984c-6.076 4.288-14.477 2.839-18.765-3.237-4.288-6.076-2.839-14.477 3.236-18.765 1.995-1.408 4.45-2.348 6.727-2.408 3.787-.099 10.488.004 13.114-.021"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M22.878 16.81c-7.61-2.205-7.61 5.768-2.807 5.661 4.704-.105 5.292 7.508-3.074 5.19M19.887 15.359v.455M19.887 28.711v.696M29.662 14.6l5.514-5.365-5.364-5.513"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 33.874,
    cy: 21.609,
    r: 1.68
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelayedIncome);
export default __webpack_public_path__ + "static/media/delayedIncome.742c73443006d66ac8ec32572c02efe2.svg";
export { ForwardRef as ReactComponent };